import styled from '@emotion/styled';

import canvasPattern from '@/assets/svg/bg/questionnaire-canvas-pattern.svg?url';
import { forMobile } from '@/shared/design-system';

const UTILITY_LINKS_TOP = 30;
const MOBILE_HEADER_HEIGHT = 56;

export const StyledPage = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100dvh',
  overflow: 'hidden',
  display: 'flex',
  gap: theme.spacing[8],
  padding: theme.spacing[8],
  boxSizing: 'border-box',
  backgroundColor: theme.colors.background.canvas,
  backgroundImage: `url("${canvasPattern}")`,
  backgroundPosition: '-2px 10px',
  letterSpacing: 0,

  [forMobile]: {
    flexDirection: 'column',
    gap: 0,
    padding: 0,
  },
}));

export const StyledFormSide = styled('main')({
  containerType: 'inline-size',
  containerName: 'questionnaire-form',
  position: 'relative',
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  justifyContent: 'center',
});

export const StyledUtilityLinks = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: UTILITY_LINKS_TOP,
  right: theme.spacing[24],
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[16],
}));

export const StyledMobileHeader = styled('header')(({ theme }) => ({
  flexShrink: 0,
  height: MOBILE_HEADER_HEIGHT,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${theme.spacing[12]}px ${theme.spacing[16]}px`,
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
}));
